"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoutingApi = void 0;
class RoutingApi {
    constructor(url, key) {
        this.url = url;
        this.key = key;
    }
    getProfiles(callback) {
        const path = "v1/profiles";
        const url = `${this.url}${path}?access_token=${this.key}`;
        const xhr = new XMLHttpRequest();
        xhr.open("GET", url);
        xhr.onload = () => {
            if (xhr.status === 200) {
                let response = JSON.parse(xhr.responseText);
                if (response.profiles) {
                    // In an older version of the API, the API gave a list for the profiles
                    // But the profiles had to be encapsulated...
                    response = response.profiles;
                }
                const parsed = response;
                parsed.forEach(p => {
                    p.id = p.type;
                    if (p.name) {
                        p.id = p.type + "." + p.name;
                    }
                });
                callback(parsed);
            }
            else {
                console.log("getProfiles failed: " + xhr.status);
            }
        };
        xhr.send();
    }
    getRoute(options, callback) {
        const path = "v1/routes";
        let loc = "";
        for (const l in options.locations) {
            const location = options.locations[l];
            if (loc.length > 0)
                loc += "&";
            loc = loc + `loc=${location.lng},${location.lat}`;
        }
        loc = loc + ``;
        let url = `${this.url}${path}?access_token=${this.key}&profile=${options.profile}&${loc}`;
        if (options.alternatives) {
            url = `${url}&alternative=${options.alternatives}`;
        }
        const xhr = new XMLHttpRequest();
        xhr.open("GET", url);
        xhr.onload = () => {
            if (xhr.status === 200) {
                const response = JSON.parse(xhr.responseText);
                const parse = response;
                callback(parse);
            }
            else {
                console.log("getRoute failed: " + xhr.status);
            }
        };
        xhr.send();
    }
    getRoutes(options, callback) {
        const path = "v1/routes";
        let loc = "";
        for (const l in options.locations) {
            const location = options.locations[l];
            if (loc.length > 0)
                loc += "&";
            loc = loc + `loc=${location.lng},${location.lat}`;
        }
        loc = loc + ``;
        let prof = "";
        for (const l in options.profiles) {
            const profile = options.profiles[l];
            if (prof.length > 0)
                prof += "&";
            prof = prof + `profile=${profile}`;
        }
        const url = `${this.url}${path}?access_token=${this.key}&${prof}&${loc}&format=multijson`;
        const xhr = new XMLHttpRequest();
        xhr.open("GET", url);
        xhr.onload = () => {
            if (xhr.status === 200) {
                const response = JSON.parse(xhr.responseText);
                const parse = response;
                callback(parse);
            }
            else {
                console.log("getRoutes failed: " + xhr.status);
            }
        };
        xhr.send();
    }
}
exports.RoutingApi = RoutingApi;
